import React from 'react';
import styled from 'styled-components';

const PortfolioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const PlaceholderCard = styled.div`
  background: ${(p) => p.theme.surface};
  border-radius: 16px;
  padding: 40px;
  box-shadow: ${(p) => p.theme.shadowSm};
  border: 1px solid ${(p) => p.theme.border};
  text-align: center;
  transition: background 0.2s ease, border-color 0.2s ease;
`;

const PlaceholderTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(p) => p.theme.textPrimary};
  margin-bottom: 16px;
`;

const PlaceholderText = styled.p`
  color: ${(p) => p.theme.textMuted};
  font-size: 16px;
  margin-bottom: 24px;
`;

const ComingSoonBadge = styled.div`
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
`;

const Portfolio = () => {
  return (
    <PortfolioContainer>
      <PlaceholderCard>
        <PlaceholderTitle>Portfolio Management</PlaceholderTitle>
        <PlaceholderText>
          Track your investments, analyze performance, and manage your crypto portfolio with advanced analytics and reporting tools.
        </PlaceholderText>
        <ComingSoonBadge>Coming Soon</ComingSoonBadge>
      </PlaceholderCard>
    </PortfolioContainer>
  );
};

export default Portfolio;
